export default __webpack_public_path__ + "static/media/no-image-placeholder.baba1a73.png";